import React from 'react'
import UserTypeDetailsContent from '../../../components/Dashboard/UserTypesListContent/View';
import { Link } from 'react-router-dom';

function UserTypeDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>User Type Details</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li><Link to="/user-types">
                  User Types
                </Link></li>
              <li>User Types Details</li>
            </ul>
          </div> */}
           
          <UserTypeDetailsContent />
        </>
      );
}

export default UserTypeDetails
